export default __webpack_public_path__ + "static/media/Aircraft4-t.dae2df60.png";